<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmh"><a id="page_xiv"></a><a id="page_xv"></a><span class="bold">Timeline</span></h2>
<table>
<tbody><tr>
<td>
<p class="ttext"><span class="bold">1066</span></p>
</td>
<td>
<p class="ttext">Battle of Hastings</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">?–1067</span></p>
</td>
<td>
<p class="ttext">William de Percy I (d.1096) comes to England</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold"><em class="italic">c.</em> 1072</span>–<span class="bold"><em class="italic">c</em>. 1135</span></p>
</td>
<td>
<p class="ttext">Alan de Percy</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">?</span>–<span class="bold"><em class="italic">c</em>. 1174/5</span></p>
</td>
<td>
<p class="ttext">William de Percy II</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">?–1202</span></p>
</td>
<td>
<p class="ttext">Maud de Percy</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">?–1203/4</span></p>
</td>
<td>
<p class="ttext">Agnes de Percy</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">?–1198</span></p>
</td>
<td>
<p class="ttext">Henry de Percy I</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1196</span></p>
</td>
<td>
<p class="ttext">Birth of William de Percy III</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1215</span></p>
</td>
<td>
<p class="ttext">Signing of Magna Carta; outbreak of First Barons’ War</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1216</span></p>
</td>
<td>
<p class="ttext">First siege of Dover, sieges of Windsor and Rochester</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1216, October</span></p>
</td>
<td>
<p class="ttext">Death of King John</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1217</span></p>
</td>
<td>
<p class="ttext">Second siege of Dover; Battles of Lincoln, Dover and Sandwich</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1217, September</span></p>
</td>
<td>
<p class="ttext">Treaty of Lambeth</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1244</span></p>
</td>
<td>
<p class="ttext">Death of Richard de Percy</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1235</span></p>
</td>
<td>
<p class="ttext">Birth of Henry de Percy II</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1245</span></p>
</td>
<td>
<p class="ttext">Death of William de Percy III</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1258</span></p>
</td>
<td>
<p class="ttext">Provisions of Oxford</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1261</span></p>
</td>
<td>
<p class="ttext">Henry III obtains a papal bull releasing him from the Provisions of Oxford</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1263</span></p>
</td>
<td>
<p class="ttext">Simon de Montfort identified as leader of baronial faction</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1264, May</span></p>
</td>
<td>
<p class="ttext">Battle of Lewes, King Henry and Prince Edward captive; de Montfort in control</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1264, May</span></p>
</td>
<td>
<p class="ttext">The Mise of Lewes concluded</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1264, June</span></p>
</td>
<td>
<p class="ttext">Constitution established by de Montfort in place, the council of nine</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><a id="page_xvi"></a><span class="bold">1265, January</span></p>
</td>
<td>
<p class="ttext">First meeting of the English Parliament in the Palace of Westminster</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1265, August</span></p>
</td>
<td>
<p class="ttext">The Battle of Evesham</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1266, October</span></p>
</td>
<td>
<p class="ttext">Terms agreed with the surviving rebels; the dictum of Kenilworth</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1267</span></p>
</td>
<td>
<p class="ttext">End of the war, terms of the dictum of Kenilworth ratified</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1272</span></p>
</td>
<td>
<p class="ttext">Death of Henry III; accession of Edward I</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1272</span></p>
</td>
<td>
<p class="ttext">Death of Henry de Percy II</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1273</span></p>
</td>
<td>
<p class="ttext">Birth of Lord Henry de Percy I</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1296</span></p>
</td>
<td>
<p class="ttext">Start of the Three-Hundred Years War</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1297</span></p>
</td>
<td>
<p class="ttext">Battle of Stirling Bridge</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1298</span></p>
</td>
<td>
<p class="ttext">Battle of Falkirk</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1301</span></p>
</td>
<td>
<p class="ttext">Birth of Lord Henry Percy II</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1309</span></p>
</td>
<td>
<p class="ttext">Percies acquire Barony of Alnwick</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1314</span></p>
</td>
<td>
<p class="ttext">Battle of Bannockburn</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1314</span></p>
</td>
<td>
<p class="ttext">Death of Lord Henry Percy I</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1320</span></p>
</td>
<td>
<p class="ttext">Birth of Lord Henry Percy III</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1333</span></p>
</td>
<td>
<p class="ttext">Battle of Halidon Hill</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1341</span></p>
</td>
<td>
<p class="ttext">Birth of Henry Percy, 1st Earl of Northumberland</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1346</span></p>
</td>
<td>
<p class="ttext">Battle of Neville’s Cross</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1352</span></p>
</td>
<td>
<p class="ttext">Death of Lord Henry Percy II</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1359</span></p>
</td>
<td>
<p class="ttext">Henry Percy accompanies the Duke of Lancaster on his French expedition</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1360</span></p>
</td>
<td>
<p class="ttext">Treaty of Brétigny</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1364</span></p>
</td>
<td>
<p class="ttext">Birth of Henry Percy (‘Hotspur’)</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1368</span></p>
</td>
<td>
<p class="ttext">Death of Lord Henry Percy III</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1369</span></p>
</td>
<td>
<p class="ttext">Resumption of French and Scottish Wars</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1372</span></p>
</td>
<td>
<p class="ttext">English defeat off La Rochelle</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1375</span></p>
</td>
<td>
<p class="ttext">Percy gains control of part of the Umfraville lands in Northumberland</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1377</span></p>
</td>
<td>
<p class="ttext">Henry becomes Marshal of England</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1377</span></p>
</td>
<td>
<p class="ttext">Death of Edward III; accession of Richard II</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><a id="page_xvii"></a><span class="bold">1377</span></p>
</td>
<td>
<p class="ttext">Percy elevated to his earldom</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1381</span></p>
</td>
<td>
<p class="ttext">Peasants’ Revolt in England; Gaunt seeks sanctuary in Scotland</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1383</span></p>
</td>
<td>
<p class="ttext">Hotspur (nearly) joins the Baltic Crusades</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1384</span></p>
</td>
<td>
<p class="ttext">Raid against Scotland by John of Gaunt</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1384</span></p>
</td>
<td>
<p class="ttext">Earl Percy marries his second wife, Maud, heiress of Gilbert de Umfraville</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1385</span></p>
</td>
<td>
<p class="ttext">Richard II leads a major raid into Scotland</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1386/7</span></p>
</td>
<td>
<p class="ttext">Hotspur does tour of duty in the Calais Pale</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1388, 5 August</span></p>
</td>
<td>
<p class="ttext">Battle of Otterburn, Hotspur defeated and captured</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1393/4</span></p>
</td>
<td>
<p class="ttext">Hotspur undertakes tour of duty in Aquitaine</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1395</span></p>
</td>
<td>
<p class="ttext">Earl of Northumberland acquires the extensive Hylton holdings</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1399</span></p>
</td>
<td>
<p class="ttext">Usurpation of Henry IV</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1400</span></p>
</td>
<td>
<p class="ttext">Henry IV expedition against the Scots</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1402</span></p>
</td>
<td>
<p class="ttext">Scots defeated at Nesbit Muir</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1402, 14 September</span></p>
</td>
<td>
<p class="ttext">Battle of Homildon</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1403, 21 July</span></p>
</td>
<td>
<p class="ttext">Battle of Shrewsbury and death of Hotspur</p>
</td>
</tr>
<tr>
<td>
<p class="ttext"><span class="bold">1408, 19 February</span></p>
</td>
<td>
<p class="ttext">Fight at Bramham Moor; death of 1st Earl of Northumberland</p>
</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Timeline.vue?1cfe97dc